if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					if ( window.syncCartDrawerFooter ) {
						window.syncCartDrawerFooter();
					}
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = cartItems.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( window.syncCartDrawerFooter ) {
				window.syncCartDrawerFooter();
			}
			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! window.syncCartDrawerFooter ) {

	window.syncCartDrawerFooter = () => {

		const sidebar = document.getElementById('site-cart-sidebar');
		const cartSubtotal = document.getElementById('AjaxCartSubtotal');
		const footerHost = sidebar ? sidebar.querySelector('[data-cart-fixed-footer]') : null;

		if ( !sidebar || !cartSubtotal || !footerHost ) {
			return;
		}

		const stickyActionsEnabled = footerHost.classList.contains('sidebar__footer--sticky-actions');
		const drawerActions = cartSubtotal.querySelector('.cart__drawer-subtotal-actions');

		if ( stickyActionsEnabled ) {
			if ( drawerActions && drawerActions.parentElement !== footerHost ) {
				footerHost.replaceChildren(drawerActions);
			}
		} else if ( drawerActions && drawerActions.parentElement === footerHost ) {
			const drawerContent = cartSubtotal.querySelector('.cart__drawer-subtotal-content');
			if ( drawerContent ) {
				drawerContent.appendChild(drawerActions);
			}
		}

		if ( window.AumaerkAbholung ) {
			window.AumaerkAbholung.bindToggles();
			window.AumaerkAbholung.bindPickers();
			window.AumaerkAbholung.applyState();
		}

		bindCartDrawerCheckoutGuard();

	}

	const showCartAbholungFeedback = (sidebar, kind) => {
		const cartRoot = sidebar ? sidebar.querySelector('[data-cart-root]') : null;
		if ( !cartRoot ) {
			return;
		}

		let feedback = cartRoot.querySelector('[data-cart-abholung-feedback]');
		if ( !feedback ) {
			feedback = document.createElement('p');
			feedback.className = 'cart__abholung-feedback';
			feedback.dataset.cartAbholungFeedback = 'true';
			feedback.setAttribute('role', 'alert');
			feedback.setAttribute('aria-live', 'assertive');
			const picker = cartRoot.querySelector('[data-cart-abholung-picker]');
			if ( picker ) {
				picker.prepend(feedback);
			} else {
				cartRoot.prepend(feedback);
			}
		}

		const message = kind === 'date'
			? 'Bitte wähle ein Datum für die Abholung.'
			: kind === 'time'
				? 'Bitte wähle eine Uhrzeit für die Abholung.'
				: 'Bitte wähle einen Abholtermin, bevor du zur Kasse gehst.';
		feedback.textContent = message;
		feedback.hidden = false;

		const dateInput = cartRoot.querySelector('[data-cart-abholung-date]');
		const timeSelect = cartRoot.querySelector('[data-cart-abholung-time]');
		if ( dateInput ) {
			if ( kind === 'date' || (kind !== 'time' && !dateInput.value) ) {
				dateInput.setAttribute('aria-invalid', 'true');
			} else {
				dateInput.removeAttribute('aria-invalid');
			}
		}
		if ( timeSelect ) {
			if ( kind === 'time' || (kind !== 'date' && (!timeSelect.value || timeSelect.disabled)) ) {
				timeSelect.setAttribute('aria-invalid', 'true');
			} else {
				timeSelect.removeAttribute('aria-invalid');
			}
		}
	}

	const clearCartAbholungFeedback = sidebar => {
		const cartRoot = sidebar ? sidebar.querySelector('[data-cart-root]') : null;
		if ( !cartRoot ) {
			return;
		}
		const feedback = cartRoot.querySelector('[data-cart-abholung-feedback]');
		if ( feedback ) {
			feedback.hidden = true;
		}
		const dateInput = cartRoot.querySelector('[data-cart-abholung-date]');
		const timeSelect = cartRoot.querySelector('[data-cart-abholung-time]');
		if ( dateInput ) dateInput.removeAttribute('aria-invalid');
		if ( timeSelect ) timeSelect.removeAttribute('aria-invalid');
	}

	const getCartDrawerAppliedDiscountCodes = sidebar => {
		const scope = sidebar || document.getElementById('site-cart-sidebar') || document;
		const discountElements = Array.from(scope.querySelectorAll('[data-js-discount]'));

		return discountElements.reduce((discountCodes, discountElement) => {
			const discountCode = typeof discountElement.dataset.jsDiscount === 'string'
				? discountElement.dataset.jsDiscount.trim()
				: '';

			if ( discountCode.length > 0 && !discountCodes.includes(discountCode) ) {
				discountCodes.push(discountCode);
			}

			return discountCodes;
		}, []);
	}

	const buildCartDrawerCheckoutUrl = discountCodes => {
		const shopifyRoot = window.Shopify && typeof window.Shopify.routes === 'object' && typeof window.Shopify.routes.root === 'string'
			? window.Shopify.routes.root
			: '/';
		const normalizedRoot = shopifyRoot.endsWith('/') ? shopifyRoot : `${shopifyRoot}/`;
		const checkoutUrl = `${normalizedRoot}checkout`;

		if ( !Array.isArray(discountCodes) || discountCodes.length === 0 ) {
			return checkoutUrl;
		}

		return `${checkoutUrl}?discount=${encodeURIComponent(discountCodes.join(','))}`;
	}

	const submitCartDrawerCheckout = (checkoutButton, event) => {
		if ( !checkoutButton ) {
			return false;
		}

		if ( event ) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}

		const sidebar = checkoutButton.closest('#site-cart-sidebar') || document.getElementById('site-cart-sidebar');
		const appliedDiscountCodes = getCartDrawerAppliedDiscountCodes(sidebar);
		const checkoutUrl = buildCartDrawerCheckoutUrl(appliedDiscountCodes);

		window.location.assign(checkoutUrl);

		return true;
	}

	const bindCartDrawerCheckoutGuard = () => {
		const sidebar = document.getElementById('site-cart-sidebar');
		const checkoutButton = sidebar ? sidebar.querySelector('#CheckOut') : null;

		if ( !sidebar || !checkoutButton || checkoutButton.dataset.lieferungGuardBound === 'true' ) {
			return;
		}

		checkoutButton.dataset.lieferungGuardBound = 'true';
		checkoutButton.addEventListener('click', event => {
			if ( checkoutButton.disabled ) {
				return;
			}

			const cartRoot = sidebar.querySelector('[data-cart-root]');
			if ( cartRoot && cartRoot.classList.contains('cart--abholung') ) {
				const isoInput = cartRoot.querySelector('[data-cart-abholung-iso]');
				const abhDateInput = cartRoot.querySelector('[data-cart-abholung-date]');
				const abhTimeSelect = cartRoot.querySelector('[data-cart-abholung-time]');
				const hasIso = isoInput && isoInput.value;
				const hasDate = abhDateInput && abhDateInput.value;
				const hasTime = abhTimeSelect && abhTimeSelect.value;
				const isExpired = hasIso && window.AumaerkAbholung && typeof window.AumaerkAbholung.isAbholterminExpired === 'function'
					? window.AumaerkAbholung.isAbholterminExpired(isoInput.value)
					: false;

				if ( !hasIso || !hasDate || !hasTime || isExpired ) {
					event.preventDefault();
					event.stopImmediatePropagation();
					if ( isExpired && window.AumaerkAbholung && typeof window.AumaerkAbholung.clearAbholtermin === 'function' ) {
						window.AumaerkAbholung.clearAbholtermin();
					}
					const kind = isExpired ? 'date' : !hasDate ? 'date' : !hasTime ? 'time' : null;
					showCartAbholungFeedback(sidebar, kind);
					const picker = cartRoot.querySelector('[data-cart-abholung-picker]');
					const drawerBody = sidebar.querySelector('.sidebar__body');
					if ( picker && drawerBody ) {
						const targetTop = drawerBody.scrollTop + picker.getBoundingClientRect().top - drawerBody.getBoundingClientRect().top - 16;
						drawerBody.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
					}
					return;
				}

				clearCartAbholungFeedback(sidebar);
				submitCartDrawerCheckout(checkoutButton, event);
				return;
			}

			if ( window.AumaerkLieferung && typeof window.AumaerkLieferung.validateBeforeCheckout === 'function' ) {
				if ( !window.AumaerkLieferung.validateBeforeCheckout() ) {
					event.preventDefault();
					event.stopImmediatePropagation();
					return;
				}
			}
			submitCartDrawerCheckout(checkoutButton, event);
		}, true);
	}

	let cartDrawerFooterSyncQueued = false;
	const queueCartDrawerFooterSync = () => {
		if ( cartDrawerFooterSyncQueued ) {
			return;
		}
		cartDrawerFooterSyncQueued = true;
		requestAnimationFrame(() => {
			cartDrawerFooterSyncQueued = false;
			window.syncCartDrawerFooter();
		});
	}

	const mountCartDrawerFooterObserver = () => {
		const sidebar = document.getElementById('site-cart-sidebar');
		if ( !sidebar || sidebar.dataset.cartFooterObserverMounted === 'true' ) {
			return;
		}
		sidebar.dataset.cartFooterObserverMounted = 'true';
		new MutationObserver(() => {
			queueCartDrawerFooterSync();
		}).observe(sidebar, {
			attributes: false,
			childList: true,
			subtree: true
		});
		queueCartDrawerFooterSync();
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', () => {
			mountCartDrawerFooterObserver();
		});
	} else {
		mountCartDrawerFooterObserver();
	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-attributes') ) {
	customElements.define(
		'cart-attributes',
		class CartAttributes extends HTMLElement {

			constructor() {

				super();

				this._prefix = window.KT_PREFIX || '';
				this.cartSubtotal = this.closest('#AjaxCartSubtotal');
				this.hiddenInputs = Array.from(this.querySelectorAll('[data-cart-attribute-input]'));
				this.checkboxes = Array.from(this.querySelectorAll('[data-cart-attribute-checkbox]'));
				this.textInputs = Array.from(this.querySelectorAll('[data-cart-attribute-text]'));
				this.conditionalFields = Array.from(this.querySelectorAll('[data-cart-attribute-conditional]'));
				this.onTextInput = debounce(this.onTextInput.bind(this), 250);

				this.syncWithGlobalState();

				this.checkboxes.forEach(checkbox=>{
					checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
				});

				this.textInputs.forEach(input=>{
					input.addEventListener('input', this.onTextInput);
				});

			}

			getState(){
				return this.hiddenInputs.reduce((state, input)=>{
					state[input.dataset.cartAttributeInput] = input.dataset.cartAttributeType === 'boolean'
						? input.value === 'true' ? 'true' : 'false'
						: input.value || '';
					return state;
				}, {});
			}

			getGlobalState(){
				if ( window.KROWN.cartAttributesState ) {
					return { ...window.KROWN.cartAttributesState };
				}
				return this.getState();
			}

			normalizeState(state){
				const normalizedState = { ...state };

				this.hiddenInputs.forEach(input=>{
					const key = input.dataset.cartAttributeInput;
					if ( input.dataset.cartAttributeType === 'boolean' ) {
						normalizedState[key] = normalizedState[key] === 'true' ? 'true' : 'false';
					} else {
						normalizedState[key] = typeof normalizedState[key] === 'string' ? normalizedState[key] : '';
					}
				});

				this.conditionalFields.forEach(field=>{
					const controller = field.dataset.cartAttributeConditional;
					if ( normalizedState[controller] !== 'true' ) {
						field.querySelectorAll('[data-cart-attribute-text]').forEach(input=>{
							normalizedState[input.dataset.cartAttributeText] = '';
						});
					}
				});

				return normalizedState;
			}

			setState(state){
				const normalizedState = this.normalizeState(state);

				this.hiddenInputs.forEach(input=>{
					const key = input.dataset.cartAttributeInput;
					input.value = input.dataset.cartAttributeType === 'boolean'
						? normalizedState[key] === 'true' ? 'true' : 'false'
						: normalizedState[key] || '';
				});

				this.checkboxes.forEach(checkbox=>{
					checkbox.checked = normalizedState[checkbox.dataset.cartAttributeCheckbox] === 'true';
				});

				this.textInputs.forEach(input=>{
					input.value = normalizedState[input.dataset.cartAttributeText] || '';
				});

				this.updateConditionalFields(normalizedState);
			}

			syncWithGlobalState(){
				const state = this.normalizeState(this.getGlobalState());
				this.setState(state);
				window.KROWN.cartAttributesState = { ...state };
			}

			syncAllInstances(state){
				const normalizedState = this.normalizeState(state);
				window.KROWN.cartAttributesState = { ...normalizedState };
				document.querySelectorAll('cart-attributes').forEach(element=>{
					element.setState(normalizedState);
				});
			}

			updateConditionalFields(state){
				this.conditionalFields.forEach(field=>{
					const controller = field.dataset.cartAttributeConditional;
					const isVisible = state[controller] === 'true';
					field.hidden = !isVisible;
					field.querySelectorAll('[data-cart-attribute-text]').forEach(input=>{
						input.disabled = !isVisible;
					});
				});
			}

			persistState(state){
				const normalizedState = this.normalizeState(state);
				this.syncAllInstances(normalizedState);

				if ( this.cartSubtotal ) {
					this.cartSubtotal.classList.add(`${this._prefix}processing`);
				}

				fetch(`${KROWN.settings.routes.cart_update_url}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body: JSON.stringify({ attributes: normalizedState })
				})
					.catch(error => {
						console.error(`Error: ${error}`);
					})
					.finally(() => {
						if ( this.cartSubtotal ) {
							this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						}
					});
			}

			onCheckboxChange(event){
				const state = this.getGlobalState();
				state[event.target.dataset.cartAttributeCheckbox] = event.target.checked ? 'true' : 'false';
				this.persistState(state);
			}

			onTextInput(event){
				const state = this.getGlobalState();
				state[event.target.dataset.cartAttributeText] = event.target.value;
				this.persistState(state);
			}

		}
	)
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}
